import Vue from 'vue';
import store from './../../store';
import shippingProviderTransformer from './../../transformers/shippingProvider';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const shippingProviders = shippingProviderTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllShippingProviders', shippingProviders);
  resolve(shippingProviders);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/shipping_providers', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/shippingProvider/all.js